<template lang="pug">
grid-container.primary(
  v-if="about.text",
  cols="auto",
  cols-md="repeat(2, calc(50% - 8px))"
)
  div
    iframe.mb-n1(
      v-responsive="mdOnly ? 1 : 16/9",
      :src="`https://www.youtube.com/embed/${getYoutubeCode(about.video)}`",
      width="100%",
      height="100%",
      frameborder="0",
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen
    )
  .pa-10.white--text.d-flex.justify-center.align-center
    div
      custom-title.mb-2(type="large", simple, white) Sobre Nós
      .text-body-1(v-html="about.text")
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle";
import { getYoutubeCode } from "@/components/utils.js";

export default {
  computed: {
    about() {
      return this.$rest("about").item;
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
  },
  beforeCreate() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });
  },
  methods: {
    getYoutubeCode,
  },
  components: {
    CustomTitle,
  },
};
</script>

<style>
</style>
